import { FC, JSX } from 'react';

import { InfoCircleOutlined } from '@ant-design/icons';
import { Flex } from 'antd';

import DatePickerFormItem from '@/components/form/form-items/default-items/date-picker-form-item/DatePickerFormItem';
import InfoTooltip from '@/components/info-tooltip/InfoTooltip';

import useIsMobile from '@/hooks/useIsMobile';

import { DEFAULT_DATE_UAS_FORMAT_MOBILE } from '@/constants/defaultDateFormat';

import styles from './DebtsBusinessInfo.module.scss';

import { useFlowsControllerContext } from '@/context/flows-controller/FlowsControllerContext';

export const DebtsBusinessInfo: FC = (): JSX.Element => {
	const { debtScheduleData } = useFlowsControllerContext();

	const isMobile = useIsMobile();
	const inputSize = isMobile ? 'small' : 'middle';

	const metadata = debtScheduleData?.metadata;
	const decodedMetadata = metadata ? atob(metadata) : '||';

	const [decodedBusinessName, decodedDoingBusinessAs] = decodedMetadata.split('||');
	const businessName =
		!decodedBusinessName || decodedBusinessName === 'null' || decodedBusinessName === 'undefined'
			? 'N/A'
			: decodedBusinessName;
	const doingBusinessAs =
		!decodedDoingBusinessAs ||
		decodedDoingBusinessAs === 'null' ||
		decodedDoingBusinessAs === 'undefined'
			? 'N/A'
			: decodedDoingBusinessAs;

	return (
		<Flex className={styles['container']}>
			<Flex className={styles['item']} gap={18} vertical>
				<span className={styles['label']}>Business Name</span>
				<span className={styles['value']}>{businessName}</span>
			</Flex>
			<Flex className={styles['item']} gap={18} vertical>
				<span className={styles['label']}>Doing Business As</span>
				<span className={styles['value']}>{doingBusinessAs}</span>
			</Flex>
			<Flex className={styles['item']}>
				<DatePickerFormItem
					datePickerProps={{
						placeholder: 'Select date',
						allowClear: false,
						format: DEFAULT_DATE_UAS_FORMAT_MOBILE,
						size: inputSize,
						variant: 'underlined',
					}}
					label={
						<span className={styles['label']}>
							As of Date*{' '}
							<InfoTooltip
								defaultOpen={true}
								description={
									'This data should match your most recent reconciled Balance Sheet, dated within the last 60 days. Ensure all financial statements are dated at month-end and based on reconciled transaction data.'
								}
								placement="bottom"
							>
								<InfoCircleOutlined
									className={styles['info-icon']}
									onClick={(e) => {
										e.preventDefault();
									}}
								/>
							</InfoTooltip>
						</span>
					}
					name="asOfDate"
				/>
			</Flex>
		</Flex>
	);
};
